// extracted by mini-css-extract-plugin
module.exports = {"parksList":"Parks_parksList__9rP4B","parkItem":"Parks_parkItem__dmgDP"};